// react core
// import { useState, useContext, useEffect, useCallback, useRef } from "react";

// material design
import Box from "@mui/material/Box";
// import Typography from "@mui/material/Typography";

// entzy config and components
import configEntzy from "components/config/ConfigEntzy";
// import MainModule from "components/main/MainModule";
// import { HeaderMenuTag } from "components/utils/common/CommonTags";
// import { scrollSnapTop, scrollTopDone } from "models/Tools";
import ContactsIndex from "components/contacts/ContactsIndex";

function MainModuleDrawer(props) {
  const content = props.content ? props.content : {};
  const component = content.component;
  const action = { type: content.action, params: content.params };

  return (
    <Box className="box-default" sx={{ pb: configEntzy.APP_SPACING_MD2X }}>
      {component === "contacts" && <ContactsIndex {...props} action={action} />}
    </Box>
  );
}

export default MainModuleDrawer;
